export default {
  GET_LEAD_TRANSFER_REPORTS_REQUEST: '@@leads-transfers/GET_LEAD_TRANSFER_REPORTS_REQUEST',
  GET_LEAD_TRANSFER_REPORTS_SUCCESS: '@@leads-transfers/GET_LEAD_TRANSFER_REPORTS_SUCCESS',
  GET_LEAD_TRANSFER_REPORTS_ERROR: '@@leads-transfers/GET_LEAD_TRANSFER_REPORTS_ERROR',
};
